import { axiosInstance as axios } from '3-foundation/ContentApi/axiosInstance';
import { SearchResultResponse } from './repository';
import logger from '3-foundation/Logging/logger';
import Application from '3-foundation/Application/ApplicationEntity';

export interface RequestInterface {
	searchUrl: string;
	query: string;
	accessToken: string;
}

export const searchConnector = async ({ searchUrl, query, accessToken }: RequestInterface): Promise<SearchResultResponse> => {
	if (!searchUrl) {
		logger.error('[500] Internal Server Error \nSearch api url is not set (undefined)');
		throw new Error('500: Internal Server Error', { cause: 'Search api url is not set (undefined)' });
	}

	const origin = Application.url?.origin;

	const headers = accessToken ? { authorization: `Bearer ${accessToken}`, hostname: origin } : { hostname: origin };

	const profiler = logger.startTimer();

	const locale = Application.locale.language;
	try {
		return await querySearchApi(searchUrl, query, headers, locale);
	} finally {
		profiler.done({ message: 'search', level: 'debug' });
	}
};

const querySearchApi = async (
	searchUrl: string,
	query: string,
	headers: { authorization?: string; hostname: string },
	locale: string,
): Promise<SearchResultResponse> => {
	const url = new URL(searchUrl);
	url.searchParams.append('query', query);
	url.searchParams.append('language', locale);
	try {
		const searchResponse = await axios({
			url: url.href,
			method: 'GET',
			maxRedirects: 0,
			headers: headers,
		});
		const { data } = searchResponse ?? {};
		const results = data?.data?.results ?? [];
		const meta = data?.meta ?? {};
		return {
			numberOfResults: meta.pagination.totalResults,
			query,
			searchResults: results,
		};
	} catch (error) {
		const message = error?.response?.data?.message ?? error;
		const statusCode = error?.response?.status || 500;
		logger.error(`[${statusCode}] Search API error \n${message} \n${error}`);
		throw new Error('Search API error', { cause: error });
	}
};
